import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { services } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#093336] via-[#0a4548] to-[#093336] text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img src="/logo-footer.png" alt="Trademark Inspire" className="h-12 mb-4" />
            <p className="text-gray-300">
              Your trusted partner in protecting intellectual property and building lasting business success. Professional trademark and legal services since inception.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/lp" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Popular Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/register-trademark" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Register Your Trademark
                </Link>
              </li>
              <li>
                <Link to="/services/llc" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  LLC Formation
                </Link>
              </li>
              <li>
                <Link to="/services/register-copyright" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/patent-search" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Patent Search
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Amazon Brand Registry
                </Link>
              </li>
              <li>
                <Link to="/services/tax-advisory" className="text-gray-300 hover:text-[#F77F00] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Tax Advisory
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail size={20} className="text-[#F77F00] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm font-medium text-white mb-1">Email</p>
                  <a href="mailto:Info@trademarkinspire.com" className="text-sm text-gray-300 hover:text-[#F77F00] transition-colors">
                    Info@trademarkinspire.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={20} className="text-[#F77F00] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm font-medium text-white mb-1">Phone</p>
                  <a href="tel:+18882029517" className="text-sm text-gray-300 hover:text-[#F77F00] transition-colors">
                    +1 (888) 2029 517
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={20} className="text-[#F77F00] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm font-medium text-white mb-1">Address</p>
                  <p className="text-sm text-gray-300">1652 W Texas St, Fairfield, CA 94533</p>
                  <p className="text-sm text-gray-300">United States</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Categories */}
        <div className="mt-12 pt-12 border-t border-white/10">
          <h4 className="text-lg font-bold mb-6 text-center">Our Service Categories</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {services.map((category, index) => (
              <div key={`category-${category.category}-${index}`}>
                <h5 className="font-bold text-sm mb-2 text-[#F77F00]">{category.category}</h5>
                <ul className="space-y-1">
                  {category.items.slice(0, 4).map((item, idx) => (
                    <li key={`${category.category}-item-${idx}-${item.path}`}>
                      <Link
                        to={item.path}
                        className="text-xs text-gray-300 hover:text-white transition-colors"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                  {category.items.length > 4 && (
                    <li key={`${category.category}-more`} className="text-xs text-gray-400 italic">+{category.items.length - 4} more</li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-sm text-gray-300">© 2026 Trademark Inspire. All rights reserved.</p>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-300 hover:text-[#F77F00] transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-400">|</span>
              <Link to="/terms" className="text-gray-300 hover:text-[#F77F00] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
